/* eslint-disable import/no-default-export */
export default () => [
  {
    country: {
      countryCode: 'AU',
      name: 'Australia',
    },
    options: [
      {
        id: 'http://graph.seek.com/RighttoWork/04c901da-2d54-4e74-808e-385fbf18ef9f',
        description: 'Australian citizen',
        verificationUrl:
          'https://certsy.com/credentials/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=right-to-work',
      },
      {
        id: 'http://graph.seek.com/RighttoWork/101f5ef1-fca2-4229-ba27-ed752ae14651',
        description: 'Graduate temporary work visa',
        verificationUrl:
          'https://certsy.com/credentials/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=right-to-work',
      },
      {
        id: 'http://graph.seek.com/RighttoWork/1992b47a-703c-47e5-8341-5ef347be0d64',
        description:
          'Temporary visa with restrictions on work hours (e.g. student visa, retirement visa)',
        verificationUrl:
          'https://certsy.com/credentials/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=right-to-work',
      },
      {
        id: 'http://graph.seek.com/RighttoWork/1fb50981-92e4-4369-b9c3-7e7c5bbcdad6',
        description: 'Temporary protection or safe haven enterprise work visa',
        verificationUrl:
          'https://certsy.com/credentials/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=right-to-work',
      },
      {
        id: 'http://graph.seek.com/RighttoWork/3997525a-f640-4df1-ab3a-37da3eae14d3',
        description:
          'Require sponsorship to work for a new employer (e.g. 482, 457)',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/55ee56ce-569f-4a0b-b201-c9bd5873df86',
        description: 'Family/partner visa with no restrictions',
        verificationUrl:
          'https://certsy.com/credentials/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=right-to-work',
      },
      {
        id: 'http://graph.seek.com/RighttoWork/5d60b917-cd0c-4b25-bb37-3c0ef971f313',
        description: 'Permanent resident and/or New Zealand citizen',
        verificationUrl:
          'https://certsy.com/credentials/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=right-to-work',
      },
      {
        id: 'http://graph.seek.com/RighttoWork/64063e8f-2373-457b-a55a-726fd094a687',
        description: 'Holiday temporary work visa',
        verificationUrl:
          'https://certsy.com/credentials/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=right-to-work',
      },
      {
        id: 'http://graph.seek.com/RighttoWork/6d4fcefd-e343-4a80-886d-348e429e15c8',
        description:
          'Temporary visa with no restrictions (e.g. doctoral student)',
        verificationUrl:
          'https://certsy.com/credentials/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=right-to-work',
      },
      {
        id: 'http://graph.seek.com/RighttoWork/84532756-a263-4055-b776-eb6a058ee86f',
        description:
          'Temporary visa with restrictions on work location (e.g. skilled regional visa 489)',
        verificationUrl:
          'https://certsy.com/credentials/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=right-to-work',
      },
      {
        id: 'http://graph.seek.com/RighttoWork/ffca1a35-1d81-4a2f-ac95-64fd3d29f119',
        description:
          'Temporary visa with restrictions on industry (e.g. temporary activity visa 408)',
        verificationUrl:
          'https://certsy.com/credentials/right-to-work?utm_source=seek&utm_medium=referral&utm_campaign=profile-verify&utm_content=right-to-work',
      },
    ],
  },
  {
    country: {
      countryCode: 'NZ',
      name: 'New Zealand',
    },
    options: [
      {
        id: 'http://graph.seek.com/RighttoWork/11e03467-19f4-48f2-8f51-6f13ef9c7c11',
        description: 'New Zealand citizen',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/2f6c7d0a-10a2-4f6d-a247-0efbfcf5d6ec',
        description:
          'Student visa with no restrictions on work hours (e.g. doctoral student)',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/3ac7d3b0-531f-401a-bed6-dd027f7fc320',
        description: 'Student visa with restrictions on work hours',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/4609ac7d-c5e1-405a-99e1-9ed45911d18a',
        description:
          'Skilled migrant temporary work visa (e.g. silver fern visa)',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/76ec425c-eb6d-46e0-b4ec-46ac44cf3bb9',
        description: 'Family/partner visa with no restrictions',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/87f388fa-a27e-49cf-9e8f-416531df55a3',
        description: 'Resident visa with no restrictions (eg. 2021)',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/9fd91297-8a20-46fa-9a29-9512f8fa8d52',
        description:
          'Graduate temporary work visa (e.g. post study work visa - open)',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/a82c908b-3411-454a-985f-ac312df86644',
        description: 'Holiday temporary work visa',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/aff7bfea-3f04-4f38-8add-0a15bb523aaf',
        description: 'Permanent resident and/or Australian citizen',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/cdfd8979-55bf-4034-aee2-a6898e3466f6',
        description:
          'Require sponsorship or a current job offer to work for a new employer (e.g. work-to-residence visa, skilled migrant resident visa)',
        verificationUrl: null,
      },
    ],
  },
  {
    country: {
      countryCode: 'GB',
      name: 'United Kingdom',
    },
    options: [
      {
        id: 'http://graph.seek.com/RighttoWork/732a2b36-3250-4366-aefa-43281c96f1c1',
        description: 'No',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/e5a51485-83c0-4197-827f-bedafb349861',
        description: 'Yes',
        verificationUrl: null,
      },
    ],
  },
  {
    country: {
      countryCode: 'HK',
      name: 'Hong Kong',
    },
    options: [
      {
        id: 'http://graph.seek.com/RighttoWork/5db97ef3-146e-4baf-997c-500845ead3f9',
        description: 'Hong Kong citizen/permanent resident',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/79324565-ac9e-4035-8de1-0516e94704e7',
        description:
          'Temporary visa with restrictions on industry (e.g. TechTAS)',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/e17cf771-52f2-4435-8a52-9c87db992df5',
        description:
          'Temporary visa with restrictions on the length of stay (eg.working holiday or QMAS visa)',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/e74889f9-33c7-4b30-842a-d44287aa772f',
        description:
          'Require sponsorship to work for a new employer (e.g. GEP - Professionals or Employment as Imported Workers visa)',
        verificationUrl: null,
      },
    ],
  },
  {
    country: {
      countryCode: 'TH',
      name: 'Thailand',
    },
    options: [
      {
        id: 'http://graph.seek.com/RighttoWork/3b03b598-0cf6-4b72-bea9-3b71c14bf80e',
        description: 'Thai Citizen/Permanent resident',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/78b309cc-6d3a-4807-a45f-ac32178fc8f7',
        description:
          'Temporary visa with restrictions on Industry (eg. Smart Visa)',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/9e4ee341-17e2-4e6c-af94-9349c8c3bdab',
        description:
          'Government or Diplomatic visa (eg. Official or Non Immigrant F Visa)',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/be2d60f9-f2a8-49c2-86ca-a52f4a9435bc',
        description:
          'Require sponsorship to work for a new employer (eg. Long stay or Tourist Visa)',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/db98c9f2-88c3-475b-8f59-69ce3ae7ded5',
        description:
          'Temporary visa with restrictions on the length of my stay (eg. Business and Investor or Non Immigrant O Visa)',
        verificationUrl: null,
      },
    ],
  },
  {
    country: {
      countryCode: 'MY',
      name: 'Malaysia',
    },
    options: [
      {
        id: 'http://graph.seek.com/RighttoWork/3c79e0ae-2c40-4915-8861-cc476510a0ed',
        description: 'Visa that lets me stay, but not work',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/5a8e9987-11bf-4f89-b39f-7361f0eff07c',
        description: 'Long Term Visit Pass with permission to work',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/a78733c9-84aa-4ff7-807d-cdc1e16b904d',
        description: 'Malaysian citizen/permanent resident',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/f1751a2a-384b-4f7d-88f7-8fa1083bab9c',
        description: 'Residence Pass-Talent (RP-T) from Talent Corp',
        verificationUrl: null,
      },
    ],
  },
  {
    country: {
      countryCode: 'SG',
      name: 'Singapore',
    },
    options: [
      {
        id: 'http://graph.seek.com/RighttoWork/019687cf-01f4-4ac8-8659-78233f4b2973',
        description: 'Employment pass/Personalised pass/S-Pass/Work permit',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/40bfdb58-672e-42c9-b76d-dbff3d50ab2b',
        description: 'Singaporean citizen/permanent resident',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/46cf6604-a784-4478-862b-658cdb03dded',
        description: 'Require sponsorship to work for a new employer',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/779970af-f272-44d3-ab93-ce191fe85f95',
        description: 'Training Employment Pass/Training Work permit',
        verificationUrl: null,
      },
    ],
  },
  {
    country: {
      countryCode: 'ID',
      name: 'Indonesia',
    },
    options: [
      {
        id: 'http://graph.seek.com/RighttoWork/078d5ed5-329b-41ca-b7b0-48f31acaa766',
        description: 'Indonesian Business Visa',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/22d7dafa-de6b-4ca6-a120-023fbe776285',
        description: 'Indonesian citizen/have a Permanent Stay Permit (KITAP)',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/2ae59845-2a72-4bd1-862f-497476fd68f0',
        description: 'Indonesian Employment pass/Work permit',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/57d316f6-4a04-441c-9605-65c6bacdf116',
        description: 'Indonesian sponsorship to work for a new employer',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/8215c75a-d230-4e6c-89ec-b408fe86a18c',
        description: 'Indonesian KITAS permit',
        verificationUrl: null,
      },
      {
        id: 'http://graph.seek.com/RighttoWork/cdd296ae-6ae0-4ddd-81c9-a1094def3f3a',
        description: 'Indonesian ABTC (APEC Business Travel Card)',
        verificationUrl: null,
      },
    ],
  },
];
